import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueSchemeListPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        schemes: {
          subtitle: "沉淀可复用的演练方案版本。",
          scopesTitle: "资源范围",
          columns: {
            schemeIdentifier: "方案编码",
            schemeTitle: "方案名称",
            imageIdentifier: "方案编码",
            imageTitle: "方案名称",
            shareMode: "共享方式",
          },
          scopes: {
            mine: "我的",
            shared_with_me: "共享给我的",
            public: "公共",
            all: "全部",
          },
          forms: {
            requiredShareMode: "请选择共享方式。",
          },
          share: {
            title: "共享演练方案",
            notice: "共享设置只影响方案引用与复制权限，不会修改方案基础信息或版本内容。",
            publicDescription: "公共方案可被具备访问权限的用户查看、引用和复制。",
            selectedUsersTitle: "已选择共享成员",
            emptyUsers: "暂未选择共享成员。",
            actions: {
              pickUsers: "选择共享成员",
            },
            fields: {
              capabilities: "授权能力",
            },
            errors: {
              selectAtLeastOneUser: "定向共享至少需要选择一名成员。",
              selectCapabilities: "请为每名共享成员选择至少一项授权能力。",
            },
            messages: {
              saveSuccess: "演练方案共享设置已保存。",
              saveFailed: "保存演练方案共享设置失败。",
            },
            capabilities: {
              view: "查看",
              reference: "引用",
              clone: "复制",
            },
          },
          shareMode: {
            private: "私有",
            shared_to_users: "定向共享",
            public: "公共",
          },
          actions: {
            enterWorkbench: "进入方案工作台",
          },
        },
        schemeCreate: {
          title: "新建演练方案",
          subtitle:
            "先用标准分步流程建立方案主对象，再进入工作台完善拓扑、阵营、任务评分与报告模板。",
        },
        schemeWorkbench: {
          title: "方案工作台",
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        schemes: {
          subtitle: "Reusable exercise scheme versions.",
          scopesTitle: "Resource scope",
          columns: {
            schemeIdentifier: "Scheme Code",
            schemeTitle: "Scheme Name",
            imageIdentifier: "Scheme Code",
            imageTitle: "Scheme Name",
            shareMode: "Share Mode",
          },
          scopes: {
            mine: "Mine",
            shared_with_me: "Shared with me",
            public: "Public",
            all: "All",
          },
          forms: {
            requiredShareMode: "Select a share mode.",
          },
          share: {
            title: "Share Exercise Scheme",
            notice:
              "Sharing controls only affect scheme reference and clone permissions. They do not change scheme basics or version content.",
            publicDescription:
              "Public schemes can be viewed, referenced, and cloned by users with access.",
            selectedUsersTitle: "Selected shared users",
            emptyUsers: "No shared users selected.",
            actions: {
              pickUsers: "Select shared users",
            },
            fields: {
              capabilities: "Capabilities",
            },
            errors: {
              selectAtLeastOneUser: "Direct sharing requires at least one user.",
              selectCapabilities: "Select at least one capability for every shared user.",
            },
            messages: {
              saveSuccess: "Exercise scheme sharing settings saved.",
              saveFailed: "Failed to save exercise scheme sharing settings.",
            },
            capabilities: {
              view: "View",
              reference: "Reference",
              clone: "Clone",
            },
          },
          shareMode: {
            private: "Private",
            shared_to_users: "Shared to users",
            public: "Public",
          },
          actions: {
            enterWorkbench: "Open Scheme Workbench",
          },
        },
        schemeCreate: {
          title: "Create Scheme",
          subtitle:
            "Use the standard step flow to create the scheme shell first, then continue topology, camps, task scoring, and report templates in the workbench.",
        },
        schemeWorkbench: {
          title: "Scheme Workbench",
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        schemes: {
          subtitle: "再利用可能な演習プラン版を蓄積します。",
          scopesTitle: "リソース範囲",
          columns: {
            schemeIdentifier: "プランコード",
            schemeTitle: "プラン名",
            imageIdentifier: "プランコード",
            imageTitle: "プラン名",
            shareMode: "共有方式",
          },
          scopes: {
            mine: "自分のもの",
            shared_with_me: "共有されたもの",
            public: "公開",
            all: "すべて",
          },
          forms: {
            requiredShareMode: "共有方式を選択してください。",
          },
          share: {
            title: "演習プランを共有",
            notice:
              "共有設定はプランの参照・複製権限にのみ影響し、基本情報や版内容は変更しません。",
            publicDescription: "公開プランはアクセス権を持つユーザーが表示、参照、複製できます。",
            selectedUsersTitle: "選択済み共有メンバー",
            emptyUsers: "共有メンバーはまだ選択されていません。",
            actions: {
              pickUsers: "共有メンバーを選択",
            },
            fields: {
              capabilities: "権限",
            },
            errors: {
              selectAtLeastOneUser: "指定共有には少なくとも 1 名のメンバーが必要です。",
              selectCapabilities: "各共有メンバーに少なくとも 1 つの権限を選択してください。",
            },
            messages: {
              saveSuccess: "演習プランの共有設定を保存しました。",
              saveFailed: "演習プランの共有設定の保存に失敗しました。",
            },
            capabilities: {
              view: "表示",
              reference: "参照",
              clone: "複製",
            },
          },
          shareMode: {
            private: "非公開",
            shared_to_users: "指定共有",
            public: "公開",
          },
          actions: {
            enterWorkbench: "プラン工作台へ進む",
          },
        },
        schemeCreate: {
          title: "プランを作成",
          subtitle:
            "標準ステップフローでプラン本体を作成し、その後ワークベンチでトポロジー、陣営、タスク採点、レポートテンプレートを整備します。",
        },
        schemeWorkbench: {
          title: "プランワークベンチ",
        },
      },
    },
  },
};
